import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { withStyles } from '@material-ui/core'

import UsageStrip from 'uiKit/UsageMeter/UsageStrip'
import { USAGE_METRIC } from 'constants/usageLimits'

/**
 * QCS-only settings page: the organisation's monthly allowances (supervision
 * sessions and care plan audits) with a way to request an increase. The meters
 * live here rather than on the Professionals / Service users pages.
 */
const styles = () => ({
  wrap: {
    fontFamily: 'var(--careco-font)',
    width: '100%',
    maxWidth: 1100,
  },
  title: {
    margin: 0,
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.25,
    color: 'var(--careco-text-primary)',
  },
  intro: {
    margin: '10px 0 24px',
    fontSize: 14,
    lineHeight: '21px',
    color: 'var(--careco-text-secondary)',
  },
})

const RequestLimits = ({ classes }) => {
  const activeBot = useSelector(state => state.activeBot)
  const botId = activeBot?.id

  return (
    <div className={classes.wrap}>
      <h2 className={classes.title}>Usage limit tracking</h2>
      <p className={classes.intro}>
        Your organisation&rsquo;s monthly allowances. Request an increase when you need more before
        the next reset.
      </p>

      {botId && (
        <UsageStrip
          botId={botId}
          metrics={[USAGE_METRIC.CARE_PLAN_AUDITS, USAGE_METRIC.SUPERVISION_SESSIONS]}
        />
      )}
    </div>
  )
}

RequestLimits.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(RequestLimits)
